import { weddingConfig } from "../config/weddingConfig";

// One slow editorial marquee — couple, date and city drifting between sections.
export const Marquee = () => {
  const items = weddingConfig.marquee;
  const sequence = [...items, ...items, ...items];

  const Track = () => (
    <div className="flex shrink-0 items-center">
      {sequence.map((text, i) => (
        <span
          key={i}
          className="flex items-center font-sans text-[11px] font-medium uppercase tracking-[0.45em] text-gold/70"
        >
          <span className="px-8">{text}</span>
          <span className="text-[9px] text-gold/40">✦</span>
        </span>
      ))}
    </div>
  );

  return (
    <div
      data-testid="editorial-marquee"
      aria-hidden="true"
      className="relative overflow-hidden border-y border-gold/20 bg-emerald-deep py-5"
    >
      <div className="marquee-track flex w-max">
        <Track />
        <Track />
      </div>
    </div>
  );
};
